import { render } from "./Apple.vue?vue&type=template&id=9f804024&scoped=true"
import script from "./Apple.vue?vue&type=script&lang=js"
export * from "./Apple.vue?vue&type=script&lang=js"

import "./Apple.vue?vue&type=style&index=0&id=9f804024&lang=scss&scoped=true"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f804024"]])

export default __exports__